import React from 'react';
import styled from 'styled-components';
import { useLanguage } from '../contexts/LanguageContext';
import logo from '../assets/logo.png';
import SubscriptionForm from './shared/SubscriptionForm';

const FooterSection = styled.footer`
  background: var(--brand-primary);
  color: var(--text-inverse);
  padding: 2rem 0;
  text-align: center;

  @media (max-width: 768px) {
    padding: 2rem 0 1.5rem;
  }
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const FooterContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`;

const FooterLinks = styled.div`
  display: flex;
  gap: 1.5rem;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: 0.5rem;

  @media (max-width: 480px) {
    gap: 1.2rem;
  }
`;

const FooterLink = styled.button`
  background: none;
  border: none;
  color: inherit;
  opacity: 0.85;
  cursor: pointer;
  font-family: inherit;
  font-size: 0.9rem;
  padding: 0;
  transition: opacity 0.2s;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: -2px;
    left: 50%;
    width: 0;
    height: 1.5px;
    background: currentColor;
    transition: width 0.3s ease, left 0.3s ease;
  }

  &:hover {
    opacity: 1;
  }

  &:hover::after {
    width: 100%;
    left: 0;
  }
`;

const FooterLogo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 1rem;
`;

const FooterLogoImg = styled.img`
  height: 30px;
  width: 30px;
  object-fit: cover;
  border-radius: 50%;
`;

const FooterLogoText = styled.span`
  font-size: 1.2rem;
  font-weight: 600;
  font-family: 'Playfair Display', serif;

  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;

const Copyright = styled.p`
  margin: 0;
  opacity: 0.9;
`;

const Footer = () => {
  const { t } = useLanguage();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offsetTop = element.offsetTop - 80;
      window.scrollTo({ top: offsetTop, behavior: 'smooth' });
    }
  };

  return (
    <FooterSection>
      <Container>
        <FooterContent data-aos="fade-up">
          <FooterLogo>
            <FooterLogoImg src={logo} alt="Hoang Uyen Da Lat Homestay" />
            <FooterLogoText>
              {t("Hoang Uyen Da Lat Homestay", "Hoàng Uyên Đà Lạt Homestay")}
            </FooterLogoText>
          </FooterLogo>
          <FooterLinks>
            <FooterLink onClick={() => scrollToSection('rooms')}>{t("Rooms", "Phòng")}</FooterLink>
            <FooterLink onClick={() => scrollToSection('activities')}>{t("Activities", "Hoạt động")}</FooterLink>
            <FooterLink onClick={() => scrollToSection('contact')}>{t("Contact", "Liên hệ")}</FooterLink>
          </FooterLinks>
          <SubscriptionForm source="footer" variant="footer" />
          <Copyright>
            &copy; 2024 {t("Hoang Uyen Da Lat Homestay. All rights reserved.", "Hoàng Uyên Đà Lạt Homestay. Bản quyền thuộc về chúng tôi.")}
          </Copyright>
        </FooterContent>
      </Container>
    </FooterSection>
  );
};

export default Footer;